import React, { useState } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { Link } from 'react-router-dom';
const BaseUrl = process.env.REACT_APP_BASE_URL;

export default function ChangePassword({ onClose }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [ConfirmationPassword, setConfirmationPassword] = useState('');
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const cookies = new Cookies();
  const token = cookies.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    try {
      await axios.post(`${BaseUrl}vendor/change_password`, {
        old_password: currentPassword,
        password: newPassword,
        password_confirmation: ConfirmationPassword
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setMessage('Password changed successfully!');
      setTimeout(() => {
        setMessage(null);
        if (onClose) onClose();
      }, 1500);
    } catch {
      setMessage('Failed to change password.');
    }
    setLoading(false);
  };

  return (
    <div className="glass rounded p-4 shadow-lg w-100" style={{ maxWidth: '28rem', margin: '0 auto' }}>
      <nav className="navbar sticky-top bg-white shadow-sm mb-3" style={{
        backdropFilter: 'blur(12px)',
        background: 'rgba(255, 255, 255, 0.8)'
      }}>
        <div className="container-fluid">
          <Link to="/" className="navbar-brand fs-4 fw-bold text-dark">
            Buffet<span className="text-warning">.</span>
          </Link>
        </div>
      </nav>

      <style>
        {`
          .glass {
            backdrop-filter: blur(12px);
            background: rgba(255, 255, 255, 0.7);
            box-shadow: 0 10px 20px rgba(0,0,0,0.07);
            border: 1px solid rgba(255,255,255,0.3);
          }
          .form-control:focus {
            border-color: #ffc107;
            box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.25);
          }
        `}
      </style>

      <h2 className="h4 fw-bold text-dark mb-4 text-center">Change Password</h2>

      {message && (
        <div className="alert alert-info text-center fw-semibold mb-3" role="alert">
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <input
            type="password"
            placeholder="Current Password"
            onChange={e => setCurrentPassword(e.target.value)}
            className="form-control"
            required
          />
        </div>

        <div className="mb-3">
          <input
            type="password"
            placeholder="New Password"
            onChange={e => setNewPassword(e.target.value)}
            className="form-control"
            required
          />
        </div>

        <div className="mb-3">
          <input
            type="password"
            placeholder="Confirm Password"
            onChange={e => setConfirmationPassword(e.target.value)}
            className="form-control"
            required
          />
        </div>

        <button
          type="submit"
          className="btn btn-common w-100 fw-semibold shadow"
          disabled={loading}
        >
          {loading ? "Changing..." : "Change Password"}
        </button>
      </form>
    </div>
  );
}
